export const getFirstOccupationOption = ({ rates = [], roomId } = {}) => {
  const { occupationOptions = {} } = rates.find((room = {}) => room.id === roomId) || {};
  const [firstOption] = Object.keys(occupationOptions);

  return firstOption ? occupationOptions[firstOption] : undefined;
};
